export default "__VITE_ASSET__HIwGpWuY__"